export enum ProductUnitTareField {
    Amount = 1,
    ProductUnit = 2,
    TareType = 3
}

(ProductUnitTareField as any).__typeName = 'ProductUnitTareField';

